import { Box, Skeleton } from "@mui/material";

import styles from "./styles";

const CreateNicheTemplateCardLoading = () => {
  return (
    <Box sx={styles.card(false)}>
      {/* Header row skeleton */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px", mb: 2 }}>
        <Skeleton variant="circular" width={48} height={48} />
        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Skeleton variant="text" width={200} height={24} />
          </Box>
          <Skeleton variant="text" width="75%" height={18} sx={{ mt: 0.5 }} />
        </Box>
      </Box>

      {/* Info box skeleton */}
      <Skeleton
        variant="rounded"
        width="100%"
        height={72}
        sx={{ borderRadius: "10px", mb: 2 }}
      />

      {/* Button skeleton */}
      <Skeleton
        variant="rounded"
        width="100%"
        height={42}
        sx={{ borderRadius: "8px" }}
      />
    </Box>
  );
};

export default CreateNicheTemplateCardLoading;
